import * as React from "react";
import type { SVGProps } from "react";
const SvgPerpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="perp_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M213.333 85.333a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H213.333zm-42.666 128a42.667 42.667 0 0 1 42.666-42.666h597.334a42.667 42.667 0 0 1 42.666 42.666v597.334a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666V213.333zm128 85.334a42.667 42.667 0 0 0 0 85.333h426.666a42.667 42.667 0 1 0 0-85.333H298.667zM512 512a42.667 42.667 0 0 1 42.667-42.667h170.666a42.667 42.667 0 1 1 0 85.334H554.667A42.667 42.667 0 0 1 512 512zm0 170.667A42.667 42.667 0 0 1 554.667 640h170.666a42.667 42.667 0 1 1 0 85.333H554.667A42.667 42.667 0 0 1 512 682.667zM371.499 478.165a42.667 42.667 0 0 0-60.331 60.331l60.33 60.33-59.647 59.649a42.667 42.667 0 1 0 60.33 60.33l87.467-87.466a42.667 42.667 0 0 0 2.347-62.635l-90.454-90.539z"
    />
  </svg>
);
export default SvgPerpIcon;
